module.exports = __webpack_public_path__ + "media/images/shape-2-97c81707c029c9d3676b35d59ab4c177.svg";